import { render } from "./GuestIcon.vue?vue&type=template&id=4e57647e"
import script from "./GuestIcon.vue?vue&type=script&lang=js"
export * from "./GuestIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/ChatIcons/GuestIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e57647e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e57647e', __exports__)) {
    api.reload('4e57647e', __exports__)
  }
  
  module.hot.accept("./GuestIcon.vue?vue&type=template&id=4e57647e", () => {
    api.rerender('4e57647e', render)
  })

}


export default __exports__